import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
/* Vue Touch Event */
import VueTouch from 'vue-touch'
Vue.use(VueTouch, {name: 'v-touch'})
VueTouch.config.swipe = {
  direction: 'horizontal'
}
/* Ripple effect */
import Ripple from 'vue-ripple-directive'
Ripple.color = 'rgba(0, 0, 0, 0.35)';
Ripple.zIndex = 99;
Vue.directive('ripple', Ripple);
// HELPERS
import './Helpers'
// VUEX STORE
import store from './store'
// Firebase
import firebase from 'firebase'
// component
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
Vue.config.productionTip = false
// middleware Auth
router.beforeEach((to, from, next) => {
	if (to.path != '/landing' && !store.state.currentUser) {
			router.push('/landing')
		}else if(to.path == '/landing' && store.state.currentUser) {
			router.push('/')
		}else {
		next()
	}
});
firebase.auth().onAuthStateChanged(user => {
	if (user) {
		store.commit('setCurrentUser', user);
		router.push('/');
	} else {
		store.commit('setCurrentUser', null)
		router.push('/landing')
	}
	new Vue({
		router,
		store,
		render: h => h(App),
	}).$mount('#app')
});